import { io } from "socket.io-client";

const socket = io("https://dshb-deposits.its.uiowa.edu");

socket.on("connect", () => {
  console.log("✅ Socket connected with id:", socket.id);
});

socket.on("connect_error", (err) => {
  console.error("❌ Socket connection error:", err);
});

socket.on("disconnect", (reason) => {
  console.log("⚠️ Socket disconnected:", reason);
});

export default socket;